import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormInfobox, FormInfoboxProps } from "@/forms-design-system/FormInfobox/FormInfobox";
import { Success } from "@/icons/outlined";

type YoureHelpingZeffyCoverFeesInfoboxProps = Omit<FormInfoboxProps, "icon" | "title" | "description" | "variant"> & {
  organizationName: string;
  bankPaymentMethodLabel: string;
  recommendBankPayment?: boolean;
};

export const YoureHelpingZeffyCoverFeesInfobox: FC<YoureHelpingZeffyCoverFeesInfoboxProps> = ({
  organizationName,
  bankPaymentMethodLabel,
  recommendBankPayment = false,
  ...rest
}) => {
  const { t } = useTranslate();

  return (
    <FormInfobox
      icon={<Success />}
      variant="emphasis"
      description={t(
        "common",
        recommendBankPayment ? "payment.bankRecommendation" : "payment.positiveZeffyCoversFees",
        { orgName: organizationName, bankPaymentMethod: bankPaymentMethodLabel }
      )}
      {...rest}
    />
  );
};
